import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const LoadableVivaEngageAppInbox: ComponentType = lazyLoadOnRender({
  loader: async () => {
    const { InboxActionButton } = await import(
      /* webpackChunkName: "4-feat-vivaengageappinbox" */ '@ms/yammer-features-app-navigation'
    );

    return { default: InboxActionButton };
  },
});
export default LoadableVivaEngageAppInbox;
